
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_public_path__;
        let url = '';
        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }
        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }
        return url + relativeUrl;
      }
import __SNOWPACK_ENV__ from '../__snowpack__/env.js';
({ url: getAbsoluteUrl('_dist_/index.js'), env: __SNOWPACK_ENV__ }).env = __SNOWPACK_ENV__;

import "../web_modules/regenerator-runtime/runtime.js";
import React from "../web_modules/react.js";
import { render } from "../web_modules/react-dom.js";
import Root from "./app.js";
import "./chat_widget.css";
render( /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(Root, null)), document.getElementById("root")); // Hot Module Replacement (HMR) - Remove this snippet to remove HMR.
// Learn more: https://www.snowpack.dev/#hot-module-replacement

if (({ url: getAbsoluteUrl('_dist_/index.js'), env: __SNOWPACK_ENV__ }).hot) {
  ({ url: getAbsoluteUrl('_dist_/index.js'), env: __SNOWPACK_ENV__ }).hot.accept();
}